<template>
  <div class="row" style="padding: 0">
    <div class="col-12 d-flex flex-row-reverse" style="padding: 0">
      <b-table-simple class="export-table balance-summary" outlined borderless style="width: 300px">
        <b-thead>
          <b-tr class="title-row">
            <b-th colspan="2">{{ lodash.startCase($t('sale_notes.resumes.total')) }}</b-th>
          </b-tr>
          <b-tr>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.purchased_shrimp')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalPurchasePrice) }}</b-th>
          </b-tr>
          <template v-if="!(model || {}).is_unload_order">
            <b-tr class="child">
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.harvest_fee')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalHarvestPrice) }}</b-th>
            </b-tr>
            <b-tr class="child">
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.additional_fee')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalAdditionalFee) }}</b-th>
            </b-tr>
            <b-tr class="child">
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.discount')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalDiscount) }}</b-th>
            </b-tr>
          </template>
          <b-tr>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.sale')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalUnload) }}</b-th>
          </b-tr>
          <b-tr>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.operational_fee')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalOperational) }}</b-th>
          </b-tr>
          <b-tr class="child">
            <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.shipping_cost')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(deliveryCost) }}</b-th>
          </b-tr>
          <b-tr class="child">
            <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.labour_cost')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(labourCost) }}</b-th>
          </b-tr>
          <b-tr class="child">
            <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.glazing')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(iceCost) }}</b-th>
          </b-tr>
          <b-tr v-if="totalOtherOperationalCost !== 0" class="child" style="color: #ACAEBD;">
            <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.other')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalOtherOperationalCost) }}</b-th>
          </b-tr>
          <b-tr>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.JALA_margin')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(jalaMargin) }}</b-th>
          </b-tr>
        </b-thead>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  name: 'summary-card-export',
  props: {
    value: { type: Object, default: function () { return {} }},
    activeTab: {type: String, default: 'admin'}
  },
  data() {
    return {
      model: this.value,
      operationalCostVisible: true,
      partnerMarginVisible: true,
      shrimpVisible: true,
    }
  },
  computed: {
    iceCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'cost_of_goods_sold' && sub_category === 'ice').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    deliveryCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'delivery').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    labourCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'labour').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    profitShare() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category, sales_reportable_type }) => category.toLowerCase() === 'expense' && sub_category === 'general_affairs_cost' && sales_reportable_type === 'App\\Models\\BalancingTransaction').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    partnerMargin() {
      return this.iceCost + this.deliveryCost + this.labourCost + this.profitShare
    },
    jalaMargin() {
      return this.value?.sale_items?.reduce((carry, { margin }) => carry + margin, 0) ?? 0
    },
    accelerationFee() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'biaya percepatan').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    pph() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'pph 22').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    saleItems() {
      return this.value?.sale_items ?? []
    },
    balanceTableItems() {
      return this.model.sale_items.map(({
                                          product: {name: product_name},
        quality,
        quantity,
        size,
        unit_price,
        total_price,
      }) => ({
        product_name: `vannamei/${this.qualityFormatter(quality)}/${this.lodash.startCase(product_name)}/Size ${size}`,
        quantity: quantity,
        price: unit_price,
        total_price: total_price,
      }))
    },
    totalOtherOperationalCost() {
      return -this.model?.sales_reports?.
          filter(({category, sub_category}) => category.toLowerCase() === 'expense' && sub_category.toLowerCase() === 'other').
          reduce((carry, {total}) => carry + total, 0) ?? 0
    },
    purchaseOrder() {
      return this.value?.trip?.trip_items[0]  ?.purchase_item?.purchase_order ?? {}
    },
    purchaseAdditionalFees() {
      return this.purchaseOrder?.purchase_additional_items?.filter(({total}) => total > 0) ?? []
    },
    purchaseDiscounts() {
      return this.purchaseOrder?.purchase_additional_items?.filter(({total}) => total < 0) ?? []
    },
    totalShrimp() {
      return this.model?.purchase_order?.total ?? 0
    },
    totalUnload() {
      if (this.activeTab.toLowerCase() === 'admin') return this.model?.total ?? 0

      let total = this.value?.sale_items?.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0

      return total + this.pph
    },
    totalAdditionalFee() {
      return this.purchaseAdditionalFees.reduce((carry, {total}) => carry + total, 0)
    },
    totalBiomass() {
      return this.saleItems.reduce((carry, { quantity }) => carry + quantity, 0)
    },
    totalDiscount() {
      return -this.purchaseDiscounts.reduce((carry, {total}) => carry + total, 0)
    },
    totalHarvestPrice() {
      return this.model
          .sale_items
          .reduce((carry, {trip_items}) => carry + trip_items
              .reduce((tripCarry, {purchase_item: {total_price}}) => tripCarry + total_price, 0), 0) ?? 0
    },
    totalPurchasePrice(){
      return this.purchaseOrder?.total ?? 0
    },
    totalPrice() {
      return this.saleItems.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0
    },
    totalSale() {
      return this.model?.total ?? 0
    },
    totalOperational() {
      return this.iceCost + this.deliveryCost + this.labourCost + this.totalOtherOperationalCost
    },
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style lang="scss" scoped>
table.balance-summary {
  thead {
    tr:nth-child(2) {
      td, th {
        padding-top: 8px !important;
      }
    }
    tr:last-child {
      td, th {
        padding-bottom: 8px !important;
      }
    }
    tr.title-row {
      color: white;
      th, td {
        padding: 8px 16px;
        border-color: #0084F3;
      }
    }
    tr {
      td, th {
        color: #161B4D;
      }
    }
    tr.child {
      td, th {
        color: #ACAEBD;
      }
    }
    td, th {
      padding: 4px 16px;
      background-color: #F9FAFB;
    }
  }
}
</style>